import GentleWidget from '../common/widget';
import GentleAppState from '../common/appstate';
import GentleServiceCustomHandler from '../service/customServiceHandler';
import GentleServiceError from '../service/error';

// 버블
var GentleComponentBubble = Object.create( GentleWidget );

GentleComponentBubble.insertUserBubble = function(opts){
    // console.log('opts >>>>>>>>!!>>',opts)
    // send : 발화전송 여부, 디폴트는 전송
    const {html, send} = opts;
    window.ChatConsole.userLog(WebChatUtils.makeUserTextObject(html));

        console.log('GentleAppState.useBrity>', GentleAppState.useBrity);
        console.log('발화내용>', html, send);
    if(send !== false){   // 디폴트는 보낸다.
        if(GentleAppState.useBrity === true){
            // console.log('발화 전송');        
            window.chatSession.chatText(html);
        }
        else
        {
            window.ChatConsole.loadingBox(true);
    
            let service;
            let param = {};
    
    
            // console.log('html', html);
            // 테스트용 
            switch(html){    
            case '상담하기':
            case '상담사연결':
                service = 'GentleServiceCallCenter.info';
                break;
            case '인트로':
            case 'intro':
                service = 'GentleServiceIntro.introInit';
                param = {ignoreCookie:true, skipAppLoading:true/*, startScene:'scene-papa-12'*/};
            break;
            case '일정':
            case '일정조회':
            case '나의 스케줄 보기':
            case 'schedule':
                service = 'GentleServiceSchedule.main';
            break;            
            case '프로필등록':
            case '프로필 작성':
            case 'Profile registration':
                service = 'GentleServiceProfile.main';
            break;            
            case 'GentleServiceTip.whatdo':
                service = 'GentleServiceTip.whatdo';
                break;            
            case '처음으로':
            case 'home':
            case 'to the first step':
                service = 'GentleServiceHome.main';
                break;
            case '타기간 후원수당 발생내역':
            case '후원수당 발생내역':
            case 'Occurrence history of general commission':
                service = 'GentleServiceBonus.huwonBonusOccurrence';
                break;
            case '마켓팅플랜':
            case 'Marketing plan description':
                service = 'GentleServiceMarketingPlan.main';
                break;
            case '신상품 목록':
            case 'Inquiry of new products':
                service = 'GentleServiceProduct.newList';
                break;
            case '세미나 일정':
            case '세미나 일정 보기':
            case 'Seminar schedule inquiry':
                service = 'GentleServiceSchedule.seminar';
                break;
            case '직급내역':
            case 'Mastership History':
                service = 'GentleServiceBonus.positionPay';
                break;
            case '후원수당':
                service = 'GentleServiceBonus.huwonBonus';
                break;
            case '소실적 맞춤 상품 추천':
            case '소실적 추천상품':
            case 'Recommend products tailored to your needs':
                service = 'GentleServiceSales.recommend';
                break;
            case '나의 매출':
            case 'Sales Inquiry':
                service = 'GentleServiceSales.popupMySales';
                break;
            case '장바구니':
            case 'Shopping cart':
                service = 'GentleServiceCart.main';
                break;
            case '로그아웃':
            case 'Log out':
                service = 'GentleServiceAccount.logoutEntry';
                break;
            case '승인잔액 조회':
            case 'Inquiry of Approval Balance':
            case 'Approved Balance Inquiry':
                service = 'GentleServiceApprove.main';
                break;
            case '회원가입안내':
            case 'Sign Up':
                service = 'GentleServiceJoin.main';
                break;
            case '센터 정보 찾기':
                service = 'GentleServiceJoin.location';
                break;
            case '고객센터 연결':
            case 'Kakao talk consultation connection':
                service = 'GentleServiceCallCenter.info';
                break;
            case '공지사항':
            case 'Notice inquiry':
                service = 'GentleServiceNotice.main';
                break;            
            case '주문내역':
            case '주문내역조회':
            case '주문내역 보기':
            case 'Order history':
                service = 'GentleServiceOrder.main';
                break;
            case '상품검색':
            case 'Product search':
                service = 'GentleServiceSearch.main';
                break;
            case '수당내역':
            case '수당조회':
            case 'Commission inquiry':
            case 'Benefits':
                service = 'GentleServiceBonus.main';
                break;
            case '매출조회':
            case '매출보기':
            case '하위 매출 보기':
            case 'Sales inquiry':
                service = 'GentleServiceSales.main';
                break;
            case '회원초대':
            case 'Member invitation':
                service = 'GentleServiceInviteMember.main';
                break;
            case '프로필수정':
            case 'Edit Profile':
                service = 'GentleServiceProfile.edit';
                break;
            case '하위회원로그인':
            case 'Downliner login':
                service = 'GentleServiceAccount.lowerList';
                break;
            case '로그인':
            case 'Log in':
                service = 'GentleServiceAccount.login';
                break;
            case '관심회원목록':
                service = 'GentleServiceAccount.lowerList';
                break;
            case '인기상품':
            case '애터미 인기상품 보기':
            case 'Search for popular products':
                service = 'GentleServiceProduct.bestList';
                break;
            case '신상품':
            case '신상품조회':
            case '애터미 신상품 보기':
            case 'Inquiry of new products':
                service = 'GentleServiceProduct.newList';
                break;
            case '주문목록':
            case 'Order history':
                service = 'GentleServiceProduct.orderList';
                break;
            default:
                // console.log('Nof found service');
                return;
            }
            
            GentleServiceCustomHandler.handler({service, intro: param});
        }
    }
}

GentleComponentBubble.createComponent = function(option){
    let {loading, user, html, error } = option;

    // if(loading){
    // }
    // else if(user === 'bot')
    {
        /* 참고해서 처리...
        if( Array.isArray(option) ){
            buttons = option;
        }else if(typeof option === 'object'){
            buttons = [];
            buttons.push(option);
        }
        */

        let texts = window.chatbotBubbles ? window.chatbotBubbles : [] ; // [];

        if(Array.isArray(html)){
            Array.prototype.push.apply(texts, html);
        }else{
            texts.push(html);
        }

        let inner = '';
        texts.forEach(element => {
            inner += `
            <div class="speech-bubble bot">
                <div class="speech-content text-only">
                    <p>${element}</p>
                </div>
            </div>
            `;
        });

        html = `
        <div>
            <div class="speech-profile">
                <i class="at-profile bot-profile"></i>
                <span class="speech-profile-name"></span>
            </div>
            ${inner}
            <div class="division"></div>
        </div>
        `;

        if(window.chatbotConsultingConnected){
            html = `
            <div>
                <div class="speech-profile">
                    <i class="at-profile consulting-profile"></i>
                    <span class="speech-consulting-name"></span>
                </div>
                ${inner}
                <div class="division"></div>
            </div>
            `;
        }

        const $bubble = $(html);

        this.setPrefix('bubble');
        this.init( $bubble );

        window.chatbotBubbles = [];
    }
}

export default GentleComponentBubble;
